/*
  mayie-home: comportamentul secțiunilor Mayie de pe prima pagină, într-un singur fișier (defer), în locul celor
  ~10 scripturi inline din tema live. Inclus de fiecare secțiune care îl folosește; rulează o singură dată pe pagină.
    1. Linkurile spre ancore (data-mayie-scroll: hero, teaserul „îngrijirea din interior”): derulare lină
       (instant cu prefers-reduced-motion), fără să schimbe adresa.
    2. Evenimente (APP-18, aceleași nume ca pe live): `hero_video_play` (dataLayer) la play pe videoul din hero;
       `problem_router_click` (dataLayer) + `mayie_router_click` (Shopify.analytics.publish) la click pe o dală.
    3. „Cele mai iubite produse”: taburile (cu tastele săgeți) și săgețile șinei pe desktop.
    4. Clipurile verticale: <video> creat abia la apăsare/click (zero bytes înainte), un singur clip odată,
       HLS doar pe WebKit, MP4-ul ușor ca rezervă.
    5. Pastila mobilă a quiz-ului, ascunsă cât timp e deschis bannerul de cookie.
*/
(() => {
  if (window.mayieHome) return;
  window.mayieHome = true;

  const reduceMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const closest = (event, selector) => (event.target instanceof Element ? event.target.closest(selector) : null);
  const pushDataLayer = (payload) => {
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(payload);
    } catch (e) {
      /* fără dataLayer */
    }
  };

  /* ----- 1. Ancore ----- */
  document.addEventListener('click', (event) => {
    const link = closest(event, 'a[data-mayie-scroll]');
    if (!link) return;
    const hash = link.getAttribute('href') || '';
    if (hash.charAt(0) !== '#' || hash.length < 2) return;
    const target = document.getElementById(decodeURIComponent(hash.slice(1)));
    if (!target) return;
    event.preventDefault();
    target.scrollIntoView({ behavior: reduceMotion() ? 'auto' : 'smooth', block: 'start' });
  });

  /* ----- 2. Evenimente ----- */
  // Faza de captură: rulează înaintea fațadei video, care scoate butonul din pagină la click.
  document.addEventListener(
    'click',
    (event) => {
      if (closest(event, '.mayie-hero__media .mayie-lite-yt__btn')) {
        pushDataLayer({ event: 'hero_video_play', video_name: 'olga-rutina-am-pm' });
      }
    },
    true
  );

  document.addEventListener('click', (event) => {
    const tile = closest(event, '.mayie-problem-router__tile[data-router-tile]');
    if (!tile) return;
    const detail = {
      tile: Number(tile.dataset.routerTile),
      label: tile.dataset.routerLabel || '',
      href: tile.getAttribute('href') || '',
    };
    pushDataLayer({ event: 'problem_router_click', ...detail });
    try {
      const publish = window.Shopify && window.Shopify.analytics && window.Shopify.analytics.publish;
      if (typeof publish === 'function') publish('mayie_router_click', detail);
    } catch (e) {
      /* fără Shopify.analytics */
    }
  });

  /* ----- 3. Produse recomandate: taburi și săgeți ----- */
  const updateOverflow = (root) => {
    root.querySelectorAll('[data-mayie-fp-track]').forEach((track) => {
      const panel = track.closest('[data-mayie-fp-panel]');
      if (panel) panel.classList.toggle('mayie-featured-products__panel--overflow', track.scrollWidth > track.clientWidth + 8);
    });
  };
  const updateAllOverflow = () => document.querySelectorAll('.mayie-featured-products').forEach(updateOverflow);

  const selectTab = (tab, focus) => {
    const root = tab.closest('.mayie-featured-products');
    if (!root) return;
    const key = tab.dataset.mayieFpTab;
    root.querySelectorAll('[data-mayie-fp-tab]').forEach((t) => {
      const active = t === tab;
      t.classList.toggle('is-active', active);
      t.setAttribute('aria-selected', active ? 'true' : 'false');
      t.setAttribute('tabindex', active ? '0' : '-1');
    });
    root.querySelectorAll('[data-mayie-fp-panel]').forEach((p) => {
      p.classList.toggle('is-active', p.dataset.mayieFpPanel === key);
    });
    if (focus) tab.focus();
    updateOverflow(root);
  };

  document.addEventListener('click', (event) => {
    const tab = closest(event, '[data-mayie-fp-tab]');
    if (tab) {
      selectTab(tab, false);
      return;
    }
    const arrow = closest(event, '[data-mayie-fp-arrow]');
    if (!arrow) return;
    const panel = arrow.closest('[data-mayie-fp-panel]');
    const track = panel && panel.querySelector('[data-mayie-fp-track]');
    if (!track) return;
    const card = track.querySelector('.mayie-featured-products__card');
    const style = window.getComputedStyle(track);
    const gap = parseFloat(style.columnGap || style.gap) || 12;
    let delta = card ? card.getBoundingClientRect().width + gap : track.clientWidth * 0.8;
    if (arrow.dataset.mayieFpArrow === 'prev') delta = -delta;
    track.scrollBy({ left: delta, behavior: reduceMotion() ? 'auto' : 'smooth' });
  });

  document.addEventListener('keydown', (event) => {
    const tab = closest(event, '[data-mayie-fp-tab]');
    if (!tab || (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft')) return;
    const tabs = Array.from(tab.parentElement.querySelectorAll('[data-mayie-fp-tab]'));
    const index = tabs.indexOf(tab);
    const next = tabs[(index + (event.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length];
    event.preventDefault();
    selectTab(next, true);
  });

  let resizeTimer;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(updateAllOverflow, 150);
  });

  /* ----- 4. Clipuri verticale ----- */
  const ua = navigator.userAgent || '';
  const hasNativeHls =
    /iPad|iPhone|iPod/.test(ua) || (/Safari/.test(ua) && !/Chrome|Chromium|Android|Edg|OPR|SamsungBrowser/.test(ua));

  const ensureVideo = (card) => {
    const existing = card.querySelector('video.mayie-ugc__video');
    if (existing) return existing;
    const template = card.querySelector('template[data-mayie-ugc-template]');
    if (!template || !template.content || !template.content.firstElementChild) return null;
    const video = template.content.firstElementChild.cloneNode(true);
    video.muted = true;
    video.controls = true;
    // HLS nativ există doar în WebKit; alte browsere spun „maybe” pentru m3u8 și apoi eșuează.
    if (!hasNativeHls) {
      const hls = video.querySelector('source[type="application/x-mpegURL"]');
      if (hls) hls.remove();
    }
    video.addEventListener('play', () => {
      document.querySelectorAll('video.mayie-ugc__video').forEach((other) => {
        if (other !== video && !other.paused) other.pause();
      });
    });
    video.addEventListener(
      'error',
      () => {
        const mp4 = video.dataset.mp4;
        if (!mp4 || video.dataset.mp4Used) return;
        video.dataset.mp4Used = '1';
        video.replaceChildren();
        const source = document.createElement('source');
        source.src = mp4;
        source.type = video.dataset.mp4Type || 'video/mp4';
        video.appendChild(source);
        video.load();
        if (card.classList.contains('mayie-ugc__media--playing')) video.play().catch(() => {});
      },
      true
    );
    card.appendChild(video);
    return video;
  };

  // Apăsarea (pointerdown) creează playerul cu ~100 ms înaintea click-ului, ca bufferul să pornească mai devreme.
  document.addEventListener(
    'pointerdown',
    (event) => {
      const button = closest(event, '[data-mayie-ugc-play]');
      if (button) ensureVideo(button.closest('[data-mayie-ugc-card]'));
    },
    { passive: true }
  );

  document.addEventListener('click', (event) => {
    const button = closest(event, '[data-mayie-ugc-play]');
    if (!button) return;
    const card = button.closest('[data-mayie-ugc-card]');
    const video = card && ensureVideo(card);
    if (!video) return;
    card.classList.add('mayie-ugc__media--playing');
    video.play().catch(() => {});
    video.focus();
  });

  /* ----- 5. Pastila quiz-ului ----- */
  const initPill = () => {
    const pill = document.querySelector('[data-mayie-quiz-pill]');
    if (!pill || pill.dataset.bound) return;
    pill.dataset.bound = 'true';

    const KEY = 'mayie-quiz-pill-dismissed';
    const dismissed = () => {
      try {
        return window.sessionStorage.getItem(KEY) === '1';
      } catch (e) {
        return false;
      }
    };
    const target = document.getElementById(pill.dataset.target || '');
    if (!target || dismissed() || !('IntersectionObserver' in window)) return;
    pill.hidden = false;

    const mobile = window.matchMedia('(max-width: 749px)');
    const banners = '#shopify-pc__banner, .cky-consent-container, #CybotCookiebotDialog, #onetrust-banner-sdk';
    const visible = (el) => el.getClientRects().length > 0 && window.getComputedStyle(el).visibility !== 'hidden';
    let passed = false;
    let inView = false;
    let closed = false;
    let started = false;

    const quizStarted = () => {
      if (!started) {
        const screen = target.querySelector('[data-quiz-screen]');
        started = !!screen && screen.getAttribute('data-quiz-screen') !== 'entry';
      }
      return started;
    };
    const update = () => {
      const bannerOpen = Array.from(document.querySelectorAll(banners)).some(visible);
      pill.classList.toggle('is-visible', mobile.matches && passed && !inView && !closed && !bannerOpen && !quizStarted());
    };

    new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        inView = entry.isIntersecting;
      });
      update();
    }).observe(target);

    // „Trecut de” = secțiunea a ieșit prin partea de SUS a ecranului. Un al doilea observator, cu marginea de jos
    // întinsă mult sub ecran, vede secțiunea „în cadru” cât timp nu e deasupra ecranului; așa starea se schimbă și
    // la un salt direct de la capătul paginii înapoi sus (primul observator n-ar vedea nicio intersecție).
    new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          passed = !entry.isIntersecting && entry.boundingClientRect.bottom <= 0;
        });
        update();
      },
      { rootMargin: '0px 0px 100000px 0px' }
    ).observe(target);

    new MutationObserver(update).observe(target, { attributes: true, subtree: true, attributeFilter: ['data-quiz-screen'] });
    mobile.addEventListener('change', update);
    document.addEventListener('visitorConsentCollected', () => setTimeout(update, 300));

    pill.querySelector('.mayie-quiz-pill__go').addEventListener('click', (event) => {
      event.preventDefault();
      target.scrollIntoView({ behavior: reduceMotion() ? 'auto' : 'smooth', block: 'start' });
      // Focusul merge pe titlul quiz-ului, ca tastatura și cititorul de ecran să ajungă acolo.
      const heading = target.querySelector('.mayie-quiz__title, h2, h3');
      if (heading) {
        if (!heading.hasAttribute('tabindex')) heading.setAttribute('tabindex', '-1');
        heading.focus({ preventScroll: true });
      }
    });

    pill.querySelector('[data-pill-close]').addEventListener('click', () => {
      closed = true;
      try {
        window.sessionStorage.setItem(KEY, '1');
      } catch (e) {
        /* stocare blocată: doar pagina curentă */
      }
      update();
    });
  };

  const init = () => {
    updateAllOverflow();
    initPill();
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
